'use client'

import { SearchForm } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { useProductReviewFilters } from '../../../../../lib/hooks/useProductReviewFilters'

export const SearchReviewInput = () => {
  const fixtures = useTranslation()
  const { filters, updateFilters } = useProductReviewFilters()

  return (
    <SearchForm
      initialValue={filters.search ?? ''}
      placeholderLabel={fixtures.magnolia.reviewsPage.search}
      onSubmit={search => updateFilters({ ...filters, search: search ?? undefined })}
      searchButtonLabel={fixtures.search.searchButtonAriaLabelSubmit}
    />
  )
}
